export default __webpack_public_path__ + "static/media/empty.a68e6572.svg";